module.exports = __webpack_public_path__ + "static/react-themes-photon-page-1c841d4d08b91f8a9463ae9c37ce1a68.jpg";